import React, { MouseEvent, useState, useEffect, useRef } from 'react';
import { Bar, HorizontalBar, LinearComponentProps } from 'react-chartjs-2';
import { formatMoneda } from '../../util/varios';
import moment from 'moment';
import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
} from 'chart.js';
import {
    Chart,
    getDatasetAtEvent,
    getElementAtEvent,
    getElementsAtEvent,
} from 'react-chartjs-2';
import axios from 'axios';
import { Mensaje } from '../../components/mensajes';
import { Torta } from '../../components/graficos/graficos';
import useTableScroll from '../../components/useTableScroll';
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import RegistrarPagodeFactura from './registrarPagoFactura';
import { Dimmer, Loader } from 'semantic-ui-react';






function GestionCuentasPagar(props) {
    const headCells = [
        {
            id: "8",
            backgroundColor: "rgba(5, 81, 130, 1)",
            color: "#ffffff",
            label: <i className="far fa-eye"></i>,
            textAlign: "center",
        },
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FACTURA N°', textAlign: 'center' },
        { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FECHA', textAlign: 'center' },
        { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'PROVEEDOR', textAlign: 'center' },
        { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'MONTO', textAlign: 'center' },
        { id: '5', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'ABONO', textAlign: 'center' },
        { id: '6', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'SALDO', textAlign: 'center' },
        { id: '7', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'STATUS', textAlign: 'center' },

    ]

    const {
        TblContainer,
        TblHead,
    } = useTableScroll(headCells);

    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [valor, setValor] = useState([]);
    const [valoru, setValoru] = useState([]);
    const [totaLClientes, setTotalClientes] = useState()
    const [total, setTotal] = useState(0.00);
    const [mostrar, setMostrar] = useState(false);
    const [totalu, setTotalu] = useState(0.00);
    const [idnot, setIdnot] = useState(0)
    const [menor, setMenor] = useState(0.00);
    const [abono, setAbono] = useState(0.0);
    const [colorF, setColorF] = useState([])
    const color = [];
    const [datos, setDatos] = useState([{
        color: '#0d6efd',
        nombre: 'Total Cobrado',
        valor: '545.555,23'
    }, {
        color: '#dc3545',
        nombre: 'Total x Cobrar',
        valor: '54.445,42'
    }
    ]);
    const [records, setRecords] = useState([]);
    const [municipiosData, setMunicipiosData] = useState([]);
    const [colorG, setColorG] = useState([
        '#0d6efd',
        '#dc3545'


    ]);
    const [rm, setRM] = useState({
        enero: 0.00,
        febrero: 0.00,
        marzo: 0.00,
        abril: 0.00,
        mayo: 0.00,
        junio: 0.00,
        julio: 0.00,
        agosto: 0.00,
        septiembre: 0.00,
        octubre: 0.00,
        noviembre: 0.00,
        diciembre: 0.00
    });
    const [activate, setActivate] = useState(false);
    const [fechaSistema, setFechaSistema] = useState(JSON.parse(sessionStorage.getItem('fechasistema')));
    const [anioActu, setAnioActu] = useState(sessionStorage.getItem('anioactu'));
    const [label, setLabel] = useState([]);
    const [labelu, setLabelu] = useState([]);

    const [data, setData] = useState();

    const [options, setOptions] = useState();



    let token = sessionStorage.getItem('jwtToken');
    let op = require('../../../public/modulos/datos');
    const ncaja = JSON.parse(sessionStorage.getItem("numcaja"));
    const accbtncntxpagarc = JSON.parse(
        sessionStorage.getItem("accbtncntxpagarc")
    );
    const txtMesPetro = useRef();
    const txtMesUTE = useRef();


    const seleccionarFacturas = (status) => {
        let endpoint = `${op.conexion}/api/registropago/seleccionarfacturascompras?&status=${status}`;

        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.length > 0) {
                        setRecords(response.data);
                    } else {
                        setRecords([]);
                    }
                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            })
            .finally(() => {
                setActivate(false);
            });
    };

    const seleccionarValorPetro = (m) => {

        let a = parseInt(fechaSistema.substring(1, 5));

        let endpoint = `${op.conexion}/api/valorpetro/valorpetrofecha?mes=${m}`;

        setActivate(true);

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {


            if (response.status == 200) {

                if (response.data.length > 0) {

                    let to = 0;
                    let te = 0;
                    let contar = 0;
                    var label = []
                    var datos = []

                    for (var i = 0; i < response.data.length; i++) {

                        if (response.data[i].anio === a.toString()) {
                            contar = contar + 1;
                            label.push(moment(response.data[i].fechaaplic).format('DD-MM'))
                            datos.push(response.data[i].valor)
                        }

                    }

                    if (contar > 1) {
                        to = contar - 2;
                        te = contar - 1;
                    }


                    setValor(datos);
                    setLabel(label);

                    let porcp = 0.00;
                    let totalpcp = 0.00;
                    let totalreal = 0.00;


                    if (datos[to] > datos[te]) {
                        porcp = datos[to] / datos[te] * 100;
                        totalreal = 100 - porcp;
                        totalpcp = formatMoneda(totalreal.toString().replace('.', ','), ',', '.', 2);
                        setMenor(totalreal);
                    } else if (datos[to] < datos[te]) {
                        porcp = datos[to] / datos[te] * 100;
                        totalreal = 100 - porcp;
                        totalpcp = formatMoneda(totalreal.toString().replace('.', ','), ',', '.', 2);
                    }
                    setTotal(totalpcp);

                }
            }

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    }

    const seleccionarValorUT = (m) => {

        let a = parseInt(fechaSistema.substring(1, 5));

        let endpoint = `${op.conexion}/api/valorute/valorutefecha?mes=${m}`;

        setActivate(true);

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {


            if (response.status == 200) {

                if (response.data.length > 0) {

                    let contar = 0;
                    let to = 0;
                    let te = 0;
                    var label = []
                    var datos = []

                    for (var i = 0; i < response.data.length; i++) {

                        if (response.data[i].anio === a.toString()) {
                            contar = contar + 1;
                            label.push(moment(response.data[i].fechaaplic).format('DD-MM'))
                            datos.push(response.data[i].valor)
                        }

                    }

                    if (contar > 1) {
                        to = contar - 2;
                        te = contar - 1;
                    }

                    setValoru(datos);
                    setLabelu(label);


                    let porcp = 0.00;
                    let totalpcp = 0.00;
                    let totalreal = 0.00;
                    if (datos[to] > datos[te]) {
                        porcp = datos[to] / datos[te] * 100;
                        totalreal = 100 - porcp;
                        totalpcp = formatMoneda(totalreal.toString().replace('.', ','), ',', '.', 2);
                        setMenor(totalreal);
                    } else if (datos[to] < datos[te]) {
                        porcp = datos[to] / datos[te] * 100;
                        totalreal = 100 - porcp;
                        totalpcp = formatMoneda(totalreal.toString().replace('.', ','), ',', '.', 2);
                    }
                    setTotalu(totalpcp);
                }
            }

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    }

    const onChange = (event) => {


        if (event.target.name === "mes") {
            const selectedIndex = event.target.options.selectedIndex;
            seleccionarValorPetro(selectedIndex);
            setValor([]);
            setLabel([]);
            setMenor([]);
            setTotal(0.00);
        } else if (event.target.name === "mesut") {
            const selectedIndex = event.target.options.selectedIndex;
            seleccionarValorUT(selectedIndex);
            setValoru([]);
            setLabelu([]);
            setMenor([]);
            setTotalu(0.00);
        }

    };


    const blanquear = () => {
        setRecords([
            {
                numero: 'F0006565',
                fecha: '2022-10-01',
                diasC: 10,
                diasV: 13,
                cliente: 'PEDRO GALINDEZ',
                monto: '122,65',
                status: 0
            },
            {
                numero: 'F0006566',
                fecha: '2022-10-01',
                diasC: 15,
                diasV: 18,
                cliente: 'JOSE FREITES',
                monto: '362,65',
                status: 0
            },
            {
                numero: 'F0006569',
                fecha: '2022-10-01',
                diasC: 90,
                diasV: 117,
                cliente: 'PEDRO GALINDEZ',
                monto: '52,65',
                status: 0
            },
            {
                numero: 'F0006570',
                fecha: '2022-10-01',
                diasC: 9,
                diasV: 8,
                cliente: 'FELIPE TORREALBA',
                monto: '982,65',
                status: 1
            },
            {
                numero: 'F0016565',
                fecha: '2022-10-01',
                diasC: 50,
                diasV: 101,
                cliente: 'RODOLFO GUZMAN',
                monto: '1212,65',
                status: 0
            },
            {
                numero: 'F0016566',
                fecha: '2022-10-01',
                diasC: 25,
                diasV: 32,
                cliente: 'ANTERO VELTRAN',
                monto: '32,65',
                status: 0
            },
            {
                numero: 'F0016569',
                fecha: '2022-10-03',
                diasC: 90,
                diasV: 95,
                cliente: 'JEAN ROCHA',
                monto: '522,65',
                status: 0
            },
            {
                numero: 'F0016570',
                fecha: '2022-10-03',
                diasC: 9,
                diasV: 17,
                cliente: 'ANTONIO GALLARDO',
                monto: '98,65',
                status: 0
            },
            {
                numero: 'F0006565',
                fecha: '2022-10-03',
                diasC: 39,
                diasV: 77,
                cliente: 'JEZER PEREZ',
                monto: '122,65',
                status: 0
            },
            {
                numero: 'F0006566',
                fecha: '2022-10-03',
                diasC: 90,
                diasV: 117,
                cliente: 'SALAD BEBSAD',
                monto: '362,65',
                status: 0
            },
            {
                numero: 'F0006569',
                fecha: '2022-10-03',
                diasC: 89,
                diasV: 165,
                cliente: 'ALBERTO PEREIRA',
                monto: '52,65',
                status: 0
            },
            {
                numero: 'F0006570',
                fecha: '2022-10-03',
                diasC: 65,
                diasV: 70,
                cliente: 'JESUS MEJIAS',
                monto: '982,65',
                status: 0
            },
            {
                numero: 'F0016565',
                fecha: '2022-10-03',
                diasC: 90,
                diasV: 117,
                cliente: 'FERNAN SIVIRA',
                monto: '1212,65',
                status: 0
            },
            {
                numero: 'F0016566',
                fecha: '2022-10-05',
                diasC: 20,
                diasV: 27,
                cliente: 'CESAR RATIA',
                monto: '32,65',
                status: 0
            },
            {
                numero: 'F0016569',
                fecha: '2022-10-05',
                diasC: 30,
                diasV: 45,
                cliente: 'JUNIOR BORJAS',
                monto: '522,65',
                status: 0
            },
            {
                numero: 'F0016570',
                fecha: '2022-10-05',
                diasC: 80,
                diasV: 97,
                cliente: 'CARLOS RODRIGUEZ',
                monto: '98,65',
                status: 0
            }
        ])
        color.slice(0)
        color.push('#007bff')
        setIdnot(0);

    }

    const dataTorta = {
        labels: ['Pagado', 'Por Pagar'],
        leyend: true,
        datasets: [
            {
                label: '#',
                data: [parseFloat(545.555, 23), parseFloat(54.445, 42)],
                backgroundColor: colorG,
                borderColor: colorG,
                borderWidth: 1,
                hoverBorderWidth: 15
            },

        ],
    };

    const optionsTorta = {
        responsive: true,
        legend: {
            position: 'top',
            display: false
        },
        title: {
            display: true,
            text: `Total en Deuda: 600.000,65`,

        }
    };

    const optionss = {
        plugins: {
            title: {
                display: true,
                text: 'Chart.js Bar Chart - Stacked',
            },
        },
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };

    const labelss = ['Timbres Fiscales', 'Impuesto 1x500', 'Impuesto Minas', 'Impuesto Producción'];

    const datas = {
        labels: labelss,
        datasets: [
            {
                label: 'Meta Presupuestaria',
                data: ["9", "7", "5", "6"],
                backgroundColor: 'rgba(53, 162, 235)',
                stack: 'Stack 1',
            },
            {
                label: 'Cobrado',
                data: ["7", "4", "9", "7"],
                backgroundColor: 'rgba(255, 99, 132)',
                stack: 'Stack 2',
            },
        ],
    };

    const optionsn = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Chart.js Bar Chart',
            },
        },
    };

    /* const labelsn = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']; */

    const datan = {
        labels: label,
        datasets: [
            {
                label: 'Variacion de la Moneda',
                data: valor,
                borderColor: 'rgba(255, 99, 132)',

            }
        ],
    };

    const optionsnu = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Chart.js Bar Chart',
            },
        },
    };


    /* const labelsn = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']; */

    const datanu = {
        labels: labelu,
        datasets: [
            {
                label: 'Variación de la Unidad Tributaria Estadal',
                data: valoru,
                borderColor: 'rgb(2, 99, 132)',

            }
        ],
    };

    const chartRef = useRef();

    const onClick = (event, index) => {

        const elements = [];

        for (let i = 0; i < records.length; i++) {

            if (records[i].cliente.trim() === event.trim()) {

                elements.push({

                    numero: records[i].numero,
                    fecha: records[i].fecha,
                    diasC: records[i].diasC,
                    diasV: records[i].diasV,
                    cliente: records[i].cliente,
                    monto: records[i].monto,
                    status: records[i].status

                })
            }



        };

        let color = colorF;
        for (let l = 0; l < totaLClientes.length; l++) {

            if (l === parseInt(index)) {
                //azul

                color.splice(l, 1, '#007bff')
            } else {
                //rojo

                colorF.splice(l, 1, '#dc3545')
            }
        }

        setColorF(color)



        setRecords(elements)
    };



    const onClickButtons = (accion) => (e) => {
        e.preventDefault()
        let array = [];
        blanquear()
        if (accion === 'vencido') {
            blanquear()
            for (let i = 0; i < records.length; i++) {
                if (moment(fechaSistema).diff(moment(records[i].fecha), 'days') > records[i].diasC) {
                    array.push({
                        numero: records[i].numero,
                        fecha: records[i].fecha,
                        diasC: records[i].diasC,
                        diasV: records[i].diasV,
                        cliente: records[i].cliente,
                        monto: records[i].monto,
                        status: records[i].status
                    })
                }
            }
        } else {
            blanquear()
            for (let i = 0; i < records.length; i++) {
                if (moment(fechaSistema).diff(moment(records[i].fecha), 'days') <= records[i].diasC) {
                    array.push({
                        numero: records[i].numero,
                        fecha: records[i].fecha,
                        diasC: records[i].diasC,
                        diasV: records[i].diasV,
                        cliente: records[i].cliente,
                        monto: records[i].monto,
                        status: records[i].status
                    })
                }
            }
        }
        setRecords(array)

    }

    useEffect(() => {

        seleccionarFacturas(0);

    }, []);

    const onGestionar = (item) => (e) => {
        if (ncaja !== "") {
            if (
                accbtncntxpagarc &&
                accbtncntxpagarc.toString().substring(0, 1) === "1"
            ) {

                setIdnot(item.idfactura);
                setAbono(item.abono);
                /* setAnticipo(item.anticipo); */
                setMostrar(true);

            } else {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación.",
                    texto: "¡No Posee Permiso para Realizar esta Acción!",
                    icono: "error",
                });
            }
        } else {
            setMensaje({
                mostrar: true,
                titulo: "Notificación.",
                texto: "¡No Posee un Número de Caja Asignada!",
                icono: "error",
            });
        }
    };

    return (
        <div className='col-md-12 mx-auto'>
            <div className='col-md-12 mt-2'>
                <div>
                    <Mensaje mensaje={mensaje}
                        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                    <div className="container-fluid px-3 py-2">
                        <div className="row col-md-10 card py-3 mx-auto">
                            <div className="row col-md-12 mx-auto">
                                <div className='col-md-6 mx-auto h-100 row'>

                                    <div className='col-md-12 card row h-100'>
                                        <div className='col-md-12 row mx-auto py-3 justify-content-end'>

                                            <div className='col-md-6 h-100 mx-auto'>
                                                <Torta data={dataTorta} height={300} options={optionsTorta} datos={datos} />
                                            </div>
                                            <div className=' col-md-6 my-auto bg-light border-azul row h-100 justify-content-center rounded mx-auto px-0'>

                                                <div className='col-md-12 h-100 mb-2'>

                                                    <div className='col-md-12 bg-primary mt-2 py-5 mx-auto rounded shadow d-flex align-items-center'>
                                                        <div class="col-md-12 justify-content-center">
                                                            <div className='col-md-12 d-flex justify-center mx-auto'>
                                                                <label class=" text-center fw-bold text-light mx-auto ">Datos Estadisticos</label>
                                                            </div>
                                                            <select className="form-select form-select-sm rounded text-center mx-auto col-md-7 fw-bold text-uppercase text-light" name='mes' defaultValue='' aria-label=".form-select-sm example" onChange={blanquear}>
                                                                <option value={0}> - Anual - </option>
                                                                <option value={1}> - Enero - </option>
                                                                <option value={2}> - Febrero - </option>
                                                                <option value={3}> - Marzo - </option>
                                                                <option value={4}> - Abril - </option>
                                                                <option value={5}> - Mayo - </option>
                                                                <option value={6}> - Junio - </option>
                                                                <option value={7}> - Julio - </option>
                                                                <option value={8}> - Agosto - </option>
                                                                <option value={9}> - Septiembre - </option>
                                                                <option value={10}> - Octubre - </option>
                                                                <option value={11}> - Noviembre - </option>
                                                                <option value={12}> - Diciembre - </option>
                                                            </select>
                                                        </div>

                                                    </div>

                                                    <button className=' btn col-md-12 bg-success mt-2 py-3 mx-auto rounded shadow d-flex align-items-center' onClick={blanquear}>
                                                        <div class="input-group input-group-sm justify-content-between">
                                                            <span class="input-group-text border-0 bg-transparent fw-bold text-light" id="inputGroup-sizing-sm">Total Fact. a Credito:</span>
                                                            <input type="text" class="form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right text-light" value={'600.000,65'} disabled aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                                        </div>

                                                    </button>
                                                    <button className=' btn col-md-12 bg-warning mt-2 py-3 mx-auto rounded shadow d-flex align-items-center' onClick={onClickButtons(' ')}>
                                                        <div class="input-group input-group-sm justify-content-between">
                                                            <span class="input-group-text border-0 bg-transparent fw-bold" id="inputGroup-sizing-sm">Total de Fact. por Vencer :</span>
                                                            <input type="text" class="form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right" value={'10'} disabled aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                                        </div>

                                                    </button>
                                                    <button className=' btn col-md-12 bg-danger mt-2 py-3 mx-auto rounded shadow d-flex align-items-center' onClick={onClickButtons('vencido')}>
                                                        <div class="input-group input-group-sm justify-content-between">
                                                            <span class="input-group-text border-0 bg-transparent fw-bold text-light" id="inputGroup-sizing-sm">Total de Fact. Vencidas:</span>
                                                            <input type="text" class="form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right text-light" value={'6'} disabled aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                                        </div>

                                                    </button>

                                                </div>
                                            </div>



                                        </div>

                                    </div>
                                </div>
                                <div className='col-md-6 py-2 row mx-auto'>
                                    <div className="col-md-12 h-100 my-auto">
                                        <div className='col-md-12 row mx-auto' style={{ fontSizeAdjust: '0.6' }}>
                                            <div class="input-group input-group-sm mb-2 col-pd-150">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">AÑO:</span>
                                                <select className="form-select form-select-sm fw-bold" aria-label=".form-select-sm example" >
                                                    <option value={0}>2022</option>
                                                    <option value={1}>2021</option>
                                                    <option value={2}>2020</option>
                                                </select>
                                            </div>
                                            <div class="input-group input-group-sm mb-2 col-pd-170">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">COBRADO:</span>
                                                <select className="form-select form-select-sm text-uppercase fw-bold" aria-label=".form-select-sm example" >
                                                    <option value={0}>Si</option>
                                                    <option value={1}>No</option>

                                                </select>
                                            </div>
                                            <div class="input-group input-group-sm mb-2 col-pd-210 px-1">
                                                <span class="input-group-text" id="inputGroup-sizing-sm">ESTATUS</span>
                                                <select className="form-select form-select-sm text-uppercase fw-bold" aria-label=".form-select-sm example" >
                                                    <option value={0}>Todas</option>
                                                    <option value={1}>Por Vencer</option>
                                                    <option value={2}>Vencida</option>

                                                </select>
                                            </div>
                                        </div>
                                        <div className="row mt-3 py-0 my-0 m-0">
                                            <h5 className="m-0 titulo-content" style={{ fontSize: 20 }}>Listado de Proveedores</h5>
                                            <hr className='w-50 my-0' />
                                            <HorizontalBar options={options} ref={chartRef} data={data} getElementAtEvent={(d) => {
                                                blanquear()
                                                onClick(d[0]._model.label, d[0]._index)
                                            }}  /*  onElementsClick={() => } */ />

                                        </div>

                                    </div>

                                </div>
                                <div className='col-md-12 row h-100'>
                                    <div className='col-md-12 row mx-auto py-3 justify-content-end'>

                                        <div className='col-md-12 h-50 mt-2 px-0 mx-0 rounded'>
                                            <TblContainer container={{ height: 220, width: '100%', overflow: 'auto', padding: '2px', fontSizeAdjust: '0.6' }} >
                                                <TblHead />
                                                <TableBody className='overflow-hidden table-bordered' >
                                                    {
                                                        records && records.map((item, index) => (
                                                            <TableRow key={index} style={{ padding: "0" }}>
                                                                <TableCell
                                                                    className="align-baseline bg-light"
                                                                    style={{
                                                                        textAlign: "center",
                                                                        width: "40px",
                                                                    }}
                                                                >
                                                                    <button
                                                                        className="btn btn-sm btn-primary rounded-circle"
                                                                        title="Gestionar Documento"
                                                                        onClick={onGestionar(item)}
                                                                    >
                                                                        <i className="fas fa-redo-alt"></i>
                                                                    </button>
                                                                </TableCell>
                                                                <TableCell className='align-baseBar bg-light' style={{ textAlign: "center", width: '80px' }} >{item.numfactura}</TableCell>
                                                                <TableCell className='align-baseline bg-light' style={{ textAlign: "center", width: '80px' }} >{moment(item.fecha).format('DD-MM-YYYY')}</TableCell>
                                                                <TableCell className='align-baseline bg-light' style={{ width: '300px' }} >{item.proveedor}</TableCell>
                                                                <TableCell className='align-baseline bg-light' style={{ textAlign: "right", width: '50px' }} >{formatMoneda(item.total.toString().replace('.', ','), ',', '.', 2)}</TableCell>
                                                                <TableCell className='align-baseline bg-light' style={{ textAlign: "right", width: '50px' }} >{formatMoneda(item.abono.toString().replace('.', ','), ',', '.', 2)}</TableCell>
                                                                <TableCell className='align-baseline bg-light' style={{ textAlign: "right", width: '50px' }} >{formatMoneda(item.montotal.toString().replace('.', ','), ',', '.', 2)}</TableCell>
                                                                <TableCell className='align-baseline bg-light' style={{ textAlign: "center", width: '80px' }} >{item.estatus === 'POR PAGAR' ? <b className='fw-bold text-danger'>{item.estatus}</b> :
                                                                    item.estatus === 'CANCELADA' ? <b className='fw-bold text-success'>{item.estatus}</b> :
                                                                        <b className='fw-bold text-warning'>{item.estatus}</b>}
                                                                </TableCell>

                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </TblContainer>
                                        </div>


                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <RegistrarPagodeFactura
                show={mostrar}
                idnot={idnot}
                abono={abono}
                /* anticipo={anticipo} */
                ope={1}
                /* combo={combo} */
                onRenderizar={seleccionarFacturas}
                onHideCancelar={() => {
                    setMostrar(false);
                }}
            />
            <Dimmer active={activate} inverted>
                <Loader inverted>cargando...</Loader>
            </Dimmer>
        </div>
    );

}

export default GestionCuentasPagar;


// WEBPACK FOOTER //
// ./src/components/finanzas/gestionCuentasPagar.js